import { Breadcrumbs, Link, Typography } from "@mui/material";

export interface CustomBreadcrumbsProps {
  items: {
    label: string;
    href: string;
    order: number;
  }[];
  lastItem: string;
}

export const CustomBreadcrumbs = ({
  items,
  lastItem,
}: CustomBreadcrumbsProps) => {
  const sortedItems = items.sort((a, b) => a.order - b.order);
  return (
    <Breadcrumbs>
      {sortedItems.map((item) => (
        <Link color="inherit" href={item.href} key={item.label}>
          {item.label}
        </Link>
      ))}
      <Typography color="text.primary">{lastItem}</Typography>
    </Breadcrumbs>
  );
};
